import EmberRouter from '@ember/routing/router';
import config from 'bullitt-time-live/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('/');
  this.route('event', function () {
    this.route('class-groups');
    this.route(
      'class-group',
      { path: 'class-group/:classgroup_id' },
      function () {
        this.route('results');
        this.route('resultsEnduro');
        this.route('resultsNotimes');
        this.route('resultsSplits');
        this.route('resultsPursuit');
		this.route('resultsPrix');
        this.route('teamResults');
        this.route('class', { path: 'class/:class_id' }, function () {
          this.route('results');
          this.route('teamResults');
        });
        this.route(
          'intermediate',
          { path: 'intermediate/:split_name' },
          function () {
            this.route('results');
          }
        );
      }
    );

    this.route('screen', { path: 'screen/:screen_id' });
    this.route('bracket', { path: 'bracket/:bracket_name' });
    this.route('config-editor');
    this.route('bracket-config-editor');
    this.route('screen-config-editor');
    this.route('eisa-scoring');
    this.route('eisa-scoring-race', { path: 'eisa-scoring/race/:race_index' });
  });
});
